import type { LoadingButtonProps } from '@mui/lab'
import type { TypographyProps } from '@mui/material'
import { Box, Typography, alpha } from '@mui/material'
import type { PropsWithChildren } from 'react'

import LoadingButton from '~/components/LoadingButton'

type BannerBarProps = PropsWithChildren<{
  backgroundColor: string
}>

export function BannerBar({ children, backgroundColor }: BannerBarProps) {
  return (
    <Box
      role="region"
      aria-label="Banner notification"
      sx={{
        bgcolor: backgroundColor,
        color: 'primary.contrastText',
        px: 4,
        py: 2
      }}
    >
      {children}
    </Box>
  )
}

type BannerButtonProps = { darkBackground?: boolean } & LoadingButtonProps

export const BannerButton = ({ darkBackground, ...rest }: BannerButtonProps) => {
  return (
    <LoadingButton
      {...rest}
      variant="outlined"
      color="inherit"
      size="small"
      sx={(theme) => {
        const color = darkBackground ? theme.palette.common.white : theme.palette.text.secondary
        return {
          color,
          borderColor: color,
          flexShrink: 0,
          '&:hover': {
            border: `1px solid ${color}`,
            backgroundColor: alpha(color, theme.palette.action.hoverOpacity * 2) + ' !important'
          }
        }
      }}
    />
  )
}

type BannerTypographyProps = TypographyProps & { bold?: true }

export function BannerTypography({ bold, ...rest }: BannerTypographyProps) {
  return <Typography component="span" variant="body2" fontWeight={bold ? 700 : undefined} {...rest} />
}
